import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  inject,
  Input,
  Output,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { ButtonComponent } from '../button/button.component';
import { Pax, Option } from '../interfaces/button-menu.interface';
import { listClass, listMoney } from 'app/constants/constants';

type PaxKey = keyof Pax;
const asset = (p: string) => new URL(p, import.meta.url).toString();

@Component({
  selector: 'app-multi-dialog-trigger',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    ButtonComponent,
    NgClass,
  ],
  templateUrl: './multi-dialog-trigger.component.html',
  styleUrl: './multi-dialog-trigger.component.css',
})
export class MultiDialogTriggerComponent {
  @Output() paxChange = new EventEmitter<Pax>();
  @Output() optionClassSelected = new EventEmitter<Option>();
  @Output() optionMoneySelected = new EventEmitter<Option>();

  readonly dialogRef = inject(MatDialogRef<MultiDialogTriggerComponent>);

  optionClass = listClass;

  optionMoney = listMoney;
  add = asset('./icons/add.svg');
  minus = asset('./icons/minus.svg');
  minusDisabled = asset('./icons/minus_disabled.svg');
  addDisabled = asset('./icons/add_disabled.svg');

  paxTypes: { key: PaxKey; label: string; description: string; min: number }[] =
    [
      { key: 'adults', label: 'Adulto', description: '+ 12 años', min: 1 },
      { key: 'children', label: 'Niños', description: '2-11 años', min: 0 },
      { key: 'infants', label: 'Bebés', description: '< 2 años', min: 0 },
    ];

  @Input() selectMoney!: Option;
  @Input() selectClass!: Option;

  @Input() pax: Pax = {
    adults: 1,
    children: 0,
    infants: 0,
  };

  totalPax = 1;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: 'money' | 'pax' | 'class';
      pax: Pax;
      class: Option;
      money: Option;
    }
  ) {
    this.selectClass = data.class;
    this.selectMoney = data.money;
    this.pax = data.pax;
  }

  onSelectMoney(value: { value: string; label: string }) {
    this.selectMoney = value;
  }
  onSelectClass(value: { value: string; label: string }) {
    this.selectClass = value;
  }

  handlerPax(action: 'increment' | 'decrement', type: PaxKey) {
    switch (type) {
      case 'adults':
        if (action === 'increment') {
          this.pax.adults++;
        }
        if (action === 'decrement') {
          if (this.pax.adults > 1) {
            this.pax.adults--;
          }
        }
        break;
      case 'children':
        if (action === 'increment') {
          this.pax.children++;
        }
        if (action === 'decrement') {
          if (this.pax.children > 0) {
            this.pax.children--;
          }
        }
        break;
      case 'infants':
        if (action === 'increment') {
          this.pax.infants++;
        }
        if (action === 'decrement') {
          if (this.pax.infants > 0) {
            this.pax.infants--;
          }
        }
        break;
    }
    this.totalPax = this.pax.adults + this.pax.children + this.pax.infants || 1;
    this.paxChange.emit(this.pax);
  }

  selectOption() {
    if (this.data.type === 'money') {
      this.dialogRef.close(this.selectMoney);
    } else if (this.data.type === 'class') {
      this.dialogRef.close(this.selectClass);
    }
    if (this.data.type === 'pax') {
      this.dialogRef.close(this.pax);
    }
  }
}
